import script from "./XIA-SearchBar.vue?vue&type=script&setup=true&lang=js"
export * from "./XIA-SearchBar.vue?vue&type=script&setup=true&lang=js"

import "./XIA-SearchBar.vue?vue&type=style&index=0&id=5482bad9&scoped=true&lang=scss"

import exportComponent from "D:\\liu\\jmzc\\jimuERPVUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5482bad9"]])

export default __exports__